import * as _ from "lodash";

export function toCamelCase(data: any): any {
  return _.mapKeys(data, (v, k) => _.camelCase(k));
}

export function toSnakeCase(data: any): any {
  return _.mapKeys(data, (v, k) => _.snakeCase(k));
}
